export interface ProductInfo {
  id: string;
  name: string;
  imagePath: string;
}

export const PRODUCTS: ProductInfo[] = [
  {
    id: 'broadzon',
    name: 'Broadzon-1GM',
    imagePath: 'assets/image/product/broadzon.jpg',
    
     },
  {
    id: 'vatarizone',
    name: 'Vatarizone',
    imagePath: 'assets/image/product/vatarizone.jpg',
    },
  {
    id: 'broadzon-cs',
    name: 'Broadzon-CS',
    imagePath: 'assets/image/product/broadzon-cs.jpg',
     },
  {
    id: 'brodzon',
    name: 'Brodzon CV 625',
    imagePath: 'assets/image/product/brodzon.jpg',
     },
  {
    id: 'curcuzone',
    name: 'Curcuzone',
    imagePath: 'assets/image/product/curcuzone.jpg',
      },
  {
    id: 'diabezone',
    name: 'Diabezone',
    imagePath: 'assets/image/product/diabezone.jpg',
    },
  {
    id: 'doxeezone',
    name: 'Doxeezone-100',
    imagePath: 'assets/image/product/doxeezone.jpg',
  },
  {
    id: 'esovien',
    name: 'Esovien',
    imagePath: 'assets/image/product/esovien.jpg',
    },
  {
    id: 'gynezone',
    name: 'Gynezone',
    imagePath: 'assets/image/product/gynezone.jpg',
     },
  {
    id: 'liverzone',
    name: 'Liverzone',
    imagePath: 'assets/image/product/liverzone.jpg',
   },
  {
    id: 'montesham',
    name: 'Montesham LC',
    imagePath: 'assets/image/product/monteshum.jpg',
   },
  {
    id: 'monthesham-lc',
    name: 'Montesham LC',
    imagePath: 'assets/image/product/monthesham-LC.jpg',
   },
  {
    id: 'nociend',
    name: 'Nociend-P',
    imagePath: 'assets/image/product/nociend.jpg',
   },
  {
    id: 'nociend-sp',
    name: 'Nociend-SP',
    imagePath: 'assets/image/product/nociend SP.jpg',
  },
  {
    id: 'pulsunate',
    name: 'Pulsunate Plus',
    imagePath: 'assets/image/product/pulsunate.jpg',
   },
  {
    id: 'rabevein',
    name: 'Rabevein',
    imagePath: 'assets/image/product/rabevein.jpg',
    },
    {
      id: 'pulsunate-plus',
      name: 'Pulsunate plus',
      imagePath: 'assets/image/product/pulsunate-plus.jpg',
      }
];


